import type { Identifier } from "ra-core";

/** Where a new thread is posted: a person (contact note) or a project. */
export type ThreadTarget = {
  key: string;
  label: string;
  kind: "contact" | "deal";
  id: Identifier;
};

export const contactThreadTarget = (
  id: Identifier,
  name: string,
): ThreadTarget => ({ key: `contact:${id}`, label: name, kind: "contact", id });

export const dealThreadTarget = (
  id: Identifier,
  name: string,
): ThreadTarget => ({ key: `deal:${id}`, label: name, kind: "deal", id });
